// extracted by mini-css-extract-plugin
export default {"selectedIcon":"style_selectedIcon__ALKdX","selected":"style_selected__3CtKn","cropsHeight":"style_cropsHeight__3cXgD","cropItem_div":"style_cropItem_div__FJ5fp"};